export default __webpack_public_path__ + "static/media/person.da4b6251.svg";